import {
  CCol,
  CForm,
  CFormFeedback,
  CFormInput,
  CFormLabel,
  CFormSelect,
  CLoadingButton,
} from '@coreui/react-pro'
import { useMemo, useRef } from 'react'
import ReactQuill from 'react-quill'
import React, { useEffect, useState } from 'react'
import { useFormik } from 'formik'
import * as Yup from 'yup'
import TeamService from 'src/service/TeamService'
import { useNavigate } from 'react-router-dom'
import ToastComponent from 'src/components/common/TaostComponent'
import PreviewImage from '../PreviewImage'
import CommonService from 'src/service/CommonService'
import 'react-quill/dist/quill.snow.css' // Import Quill styles
import SponsorService from 'src/service/SponsorService'
const EditForm = (props) => {
  const [infoData, setInfoData] = useState({})
  const [infoText, setInfoText] = useState('')
  useEffect(() => {
    if (props.selectedTeamId === props.teamId) {
      CommonService.getHeaderInfoDetails(props.teamId)
        .then((res) => {
          if (res.status === 200) {
            setInfoData(res.data)
            setInfoText(res.data?.info_text)
          }
        })
        .catch((e) => {
          ToastComponent(e.response?.data?.message, 'error')
          setLoader(false)
        })
    }
  }, [props])
  const headerText = [
    'Settings',
    'Controls',
    'Players',
    'Fixtures',
    'Members',
    'Trades',
    'Analytics',
    'Bonus Cards',
    'Bracket Battle',
    'Head-2-Head',
    'Timeline',
    'Team of the Round',
    'Votes',
    'Pricing',
  ]
  const [loader, setLoader] = useState(false)
  const validationSchema = Yup.object().shape({
    page_name: Yup.string().required('Page Name is required'),
    header_text: Yup.string().required('Header Text is required'),
    label_name: Yup.string().required('Label Name is required'),
  })
  const formik = useFormik({
    initialValues: {
      page_name: infoData?.page_name,
      label_name: infoData?.label_name,
      share_link: infoData?.share_link,
      info_text: infoData?.info_text,
      tooltip: infoData?.tooltip,
      header_text: infoData?.header_text,
    },
    enableReinitialize: true,
    validationSchema,
    onSubmit: (data, actions) => {
      var formData = new FormData()
      formData.append('id', props.teamId)
      formData.append('header_text', data.header_text)
      formData.append('label_name', data.label_name)
      formData.append('tooltip', data.tooltip)
      formData.append('page_name', data.page_name)
      formData.append('share_link', data.share_link)
      formData.append('info_text', infoText)
      actions.resetForm({
        values: {
          name: '',
        },
      })
      setLoader(true)
      CommonService.editHeaderInfo(formData).then((res) => {
        if (res.status === 200) {
          props.fetchData(
            props.activePage,
            props.columnFilter,
            props.columnSorter,
            props.itemsPerPage,
          )
          ToastComponent(res.message, 'success')
          setLoader(false)
        }
      })
      props.onSubmit()
    },
  })

  const quillRef = useRef()
  const imageHandler = (e) => {
    const editor = quillRef.current.getEditor()
    const input = document.createElement('input')
    input.setAttribute('type', 'file')
    input.setAttribute('accept', 'image/*')
    input.click()

    input.onchange = async () => {
      const file = input.files[0]
      if (/^image\//.test(file.type)) {
        const formData = new FormData()
        formData.append('image', file)
        const res = await SponsorService.imageUplaod(formData) // upload data into server or aws or cloudinary
        const url = res?.url
        editor.insertEmbed(editor.getSelection(), 'image', url)
      } else {
        ToastComponent('You could only upload images.', 'error')
      }
    }
  }
  const modules = useMemo(
    () => ({
      toolbar: {
        container: [
          [{ header: [1, 2, 3, 4, 5, 6, false] }],
          ['bold', 'italic', 'underline', 'strike'],
          [{ list: 'ordered' }, { list: 'bullet' }, { indent: '-1' }, { indent: '+1' }],
          ['image', 'link'],
          [
            {
              color: [
                '#000000',
                '#e60000',
                '#ff9900',
                '#ffff00',
                '#008a00',
                '#0066cc',
                '#9933ff',
                '#ffffff',
                '#facccc',
                '#ffebcc',
                '#ffffcc',
                '#cce8cc',
                '#cce0f5',
                '#ebd6ff',
                '#bbbbbb',
                '#f06666',
                '#ffc266',
                '#ffff66',
                '#66b966',
                '#66a3e0',
                '#c285ff',
                '#888888',
                '#a10000',
                '#b26b00',
                '#b2b200',
                '#006100',
                '#0047b2',
                '#6b24b2',
                '#444444',
                '#5c0000',
                '#663d00',
                '#666600',
                '#003700',
                '#002966',
                '#3d1466',
              ],
            },
          ],
        ],
        handlers: {
          image: imageHandler,
        },
      },
    }),
    [],
  )

  return (
    <>
      <CForm className="row g-3" onSubmit={formik.handleSubmit}>
        <CCol md={3}>
          <CFormLabel className="fw-bold" htmlFor="grade_name">
            Accordian Heading *
          </CFormLabel>
          <CFormSelect
            aria-label="Select Comp"
            name="header_text"
            className={
              'form-control' +
              (formik.errors.header_text && formik.touched.header_text ? ' is-invalid' : '')
            }
            value={formik.values.header_text} // Bind selected value to formik's value
            onChange={formik.handleChange}
            id="header_text"
          >
            <option value={0}>Select Header</option>
            {headerText.map((header, index) => (
              <option key={index} value={header}>
                {header}
              </option>
            ))}
          </CFormSelect>
          {formik.errors.header_text && formik.touched.header_text && (
            <CFormFeedback invalid>{formik.errors.header_text}</CFormFeedback>
          )}
        </CCol>
        <CCol md={3}>
          <CFormLabel className="fw-bold" htmlFor="name">
            Page Name
          </CFormLabel>
          <input
            type="text"
            name="page_name"
            className={
              'form-control' +
              (formik.errors.page_name && formik.touched.page_name ? ' is-invalid' : '')
            }
            id="page_name"
            placeholder="Page Name"
            defaultValue={infoData?.page_name}
            onChange={formik.handleChange}
          />
          {formik.errors.page_name && formik.touched.page_name && (
            <CFormFeedback invalid>{formik.errors.page_name}</CFormFeedback>
          )}
        </CCol>
        <CCol md={3}>
          <CFormLabel className="fw-bold" htmlFor="name">
            Label Name
          </CFormLabel>
          <input
            type="text"
            name="label_name"
            className={
              'form-control' +
              (formik.errors.label_name && formik.touched.label_name ? ' is-invalid' : '')
            }
            id="label_name"
            placeholder="Page Name"
            defaultValue={infoData?.label_name}
            onChange={formik.handleChange}
          />
          {formik.errors.label_name && formik.touched.label_name && (
            <CFormFeedback invalid>{formik.errors.label_name}</CFormFeedback>
          )}
        </CCol>
        <CCol md={3}>
          <CFormLabel className="fw-bold" htmlFor="name">
            Tooltip
          </CFormLabel>
          <CFormInput
            placeholder="Tooltip"
            className={
              'form-control' +
              (formik.errors.tooltip && formik.touched.tooltip ? ' is-invalid' : '')
            }
            value={formik.values.tooltip}
            onChange={formik.handleChange}
            aria-label="tooltip"
            id="tooltip"
          />
          {formik.errors.tooltip && formik.touched.tooltip && (
            <CFormFeedback invalid>{formik.errors.tooltip}</CFormFeedback>
          )}
        </CCol>
        <CCol md={3}>
          <CFormLabel className="fw-bold" htmlFor="name">
            Share Link
          </CFormLabel>
          <input
            type="text"
            name="share_link"
            className={
              'form-control' +
              (formik.errors.share_link && formik.touched.share_link ? ' is-invalid' : '')
            }
            id="share_link"
            placeholder="Share Link"
            defaultValue={infoData?.share_link}
            onChange={formik.handleChange}
          />
          {formik.errors.share_link && formik.touched.share_link && (
            <CFormFeedback invalid>{formik.errors.share_link}</CFormFeedback>
          )}
        </CCol>
        <CCol md={12}>
          <CFormLabel className="fw-bold" htmlFor="About Game">
            Content
          </CFormLabel>
          <ReactQuill
            theme="snow"
            ref={quillRef}
            value={infoText}
            onChange={setInfoText}
            modules={modules}
          />
        </CCol>

        <CCol md={6}>
          <CLoadingButton type="submit" color="success" variant="outline" loading={loader}>
            Submit
          </CLoadingButton>
        </CCol>
      </CForm>
    </>
  )
}

export default EditForm
